import { Regexxgw0gjiagf4z as Regex } from '../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  _UByte___init__impl__g9hnc43ude1dscg1q30 as _UByte___init__impl__g9hnc4,
  _UByte___get_data__impl__jof9qr2p2xx2i2jvnz8 as _UByte___get_data__impl__jof9qr,
} from '../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { toString3o7ifthqydp6e as toString } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DeferToContextualUuidSerializer_getInstance3t53sgmdyoff4 as DeferToContextualUuidSerializer_getInstance } from './UUID.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.i2p_1 = Regex().qh('^[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}$');
        this.j2p_1 = '0123456789abcdef';
      }
      k2p() {
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = window.crypto.randomUUID();
        return new (UUID())((!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE());
      }
      xw(uuidString) {
        return new (UUID())(uuidString);
      }
      d4z(bytes) {
        var out = '';
        var i = 0;
        // Inline function 'kotlin.repeat' call
        var inductionVariable = 0;
        if (inductionVariable < 4)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var _unary__edvuaz = i;
            i = _unary__edvuaz + 1 | 0;
            // Inline function 'kotlin.toUByte' call
            var this_0 = bytes[_unary__edvuaz];
            // Inline function 'kotlin.UByte.toInt' call
            var this_1 = _UByte___init__impl__g9hnc4(this_0);
            var byte = _UByte___get_data__impl__jof9qr(this_1) & 255;
            out = out + toString(charCodeAt(Companion_getInstance().j2p_1, byte >> 4 & 15));
            out = out + toString(charCodeAt(Companion_getInstance().j2p_1, byte & 15));
          }
           while (inductionVariable < 4);
        out = out + '-';
        // Inline function 'kotlin.repeat' call
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 2)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _unary__edvuaz_0 = i;
            i = _unary__edvuaz_0 + 1 | 0;
            // Inline function 'kotlin.toUByte' call
            var this_2 = bytes[_unary__edvuaz_0];
            // Inline function 'kotlin.UByte.toInt' call
            var this_3 = _UByte___init__impl__g9hnc4(this_2);
            var byte_0 = _UByte___get_data__impl__jof9qr(this_3) & 255;
            out = out + toString(charCodeAt(Companion_getInstance().j2p_1, byte_0 >> 4 & 15));
            out = out + toString(charCodeAt(Companion_getInstance().j2p_1, byte_0 & 15));
          }
           while (inductionVariable_0 < 2);
        out = out + '-';
        // Inline function 'kotlin.repeat' call
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 2)
          do {
            var index_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var _unary__edvuaz_1 = i;
            i = _unary__edvuaz_1 + 1 | 0;
            // Inline function 'kotlin.toUByte' call
            var this_4 = bytes[_unary__edvuaz_1];
            // Inline function 'kotlin.UByte.toInt' call
            var this_5 = _UByte___init__impl__g9hnc4(this_4);
            var byte_1 = _UByte___get_data__impl__jof9qr(this_5) & 255;
            out = out + toString(charCodeAt(Companion_getInstance().j2p_1, byte_1 >> 4 & 15));
            out = out + toString(charCodeAt(Companion_getInstance().j2p_1, byte_1 & 15));
          }
           while (inductionVariable_1 < 2);
        out = out + '-';
        // Inline function 'kotlin.repeat' call
        var inductionVariable_2 = 0;
        if (inductionVariable_2 < 2)
          do {
            var index_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var _unary__edvuaz_2 = i;
            i = _unary__edvuaz_2 + 1 | 0;
            // Inline function 'kotlin.toUByte' call
            var this_6 = bytes[_unary__edvuaz_2];
            // Inline function 'kotlin.UByte.toInt' call
            var this_7 = _UByte___init__impl__g9hnc4(this_6);
            var byte_2 = _UByte___get_data__impl__jof9qr(this_7) & 255;
            out = out + toString(charCodeAt(Companion_getInstance().j2p_1, byte_2 >> 4 & 15));
            out = out + toString(charCodeAt(Companion_getInstance().j2p_1, byte_2 & 15));
          }
           while (inductionVariable_2 < 2);
        out = out + '-';
        // Inline function 'kotlin.repeat' call
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < 6)
          do {
            var index_3 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            var _unary__edvuaz_3 = i;
            i = _unary__edvuaz_3 + 1 | 0;
            // Inline function 'kotlin.toUByte' call
            var this_8 = bytes[_unary__edvuaz_3];
            // Inline function 'kotlin.UByte.toInt' call
            var this_9 = _UByte___init__impl__g9hnc4(this_8);
            var byte_3 = _UByte___get_data__impl__jof9qr(this_9) & 255;
            out = out + toString(charCodeAt(Companion_getInstance().j2p_1, byte_3 >> 4 & 15));
            out = out + toString(charCodeAt(Companion_getInstance().j2p_1, byte_3 & 15));
          }
           while (inductionVariable_3 < 6);
        return new (UUID())(out);
      }
      k2a() {
        return DeferToContextualUuidSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var UUIDClass;
function UUID() {
  if (UUIDClass === VOID) {
    class $ {
      constructor(string) {
        Companion_getInstance();
        this.e4z_1 = string;
        if (!Companion_getInstance().i2p_1.rh(this.e4z_1))
          throw IllegalArgumentException().a1('Invalid UUID string: ' + this.e4z_1);
      }
      f4z(other) {
        return compareTo(this.e4z_1, other.e4z_1);
      }
      d(other) {
        return this.f4z(other instanceof UUID() ? other : THROW_CCE());
      }
      toString() {
        return this.e4z_1;
      }
      hashCode() {
        return getStringHashCode(this.e4z_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UUID()))
          return false;
        if (!(this.e4z_1 === other.e4z_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'UUID', VOID, VOID, [Comparable()], VOID, VOID, {0: DeferToContextualUuidSerializer_getInstance});
    UUIDClass = $;
  }
  return UUIDClass;
}
//region block: exports
export {
  UUID as UUID21wrnrlmk5y1y,
  Companion_getInstance as Companion_getInstance3n9as6ds1py67,
};
//endregion

//# sourceMappingURL=UUID.js.mjs.map
